import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/site';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const first = document.getElementById('first-cta');
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-34" data-mp="2aurz27eaytra">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-35" data-mp="38ayx8je9gfiq">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl border-b-4 border-go-deep bg-go px-5 py-4 text-white shadow-[0_14px_36px_-8px_rgba(0,0,0,0.5)] hover:bg-go-dark" data-id="element-36" data-mp="333jcz3woka29">
            <span className="font-display text-base font-extrabold uppercase tracking-tight sm:text-lg" data-id="element-37" data-mp="2u8waogmbcdu8">Get instant access — $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-38" data-mp="2kdkya4ydnipn" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}